
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    
import { createApolloClient } from "lib/apollo/apollo"
import getHeaderAndFooter from "lib/apollo/queries/globals"
import Layout from "components/Layout"
import { useFormStore } from "components/forms/ArchitektAufAnfrage/formStore"
import TitleStep from "../../components/forms/ArchitektAufAnfrage/TitleStep"
import QuestionStep from "../../components/forms/ArchitektAufAnfrage/QuestionStep"
import OverviewStep from "../../components/forms/ArchitektAufAnfrage/OverviewStep"

const STEP_TYPES = {
  title_step: TitleStep,
  question_step: QuestionStep,
  overview_step: OverviewStep,
}

function FormPage({ content = {}, globals = {} }) {
  const { getStep } = useFormStore((state) => ({
    getStep: state.getStep,
  }))

  const StepElement = STEP_TYPES[getStep().step_type]

  return (
    <>
      <Layout
        globals={globals}
        content={{
          ...content,
          seo_title: "Architekt on Demand - Planmaschine",
        }}
      >
        {StepElement && <StepElement />}
      </Layout>
    </>
  )
}

 const _getServerSideProps = async ({ params = null, previewData = null }) => {
  const apollo = createApolloClient(previewData?.token ?? null)

  const [globals] = await Promise.all([getHeaderAndFooter(apollo)])

  if (!globals) {
    return {
      notFound: true,
    }
  }

  return {
    props: {
      globals,
    },
    // revalidate: 30,
  }
}

export default FormPage


    export async function getServerSideProps(ctx) {
        let res = _getServerSideProps(ctx)
        if(typeof res.then === 'function') res = await res
        return {
          
          ...res,
          props: {
            ...(res.props || {}),
            ...(await __loadNamespaces({
              ...ctx,
              pathname: '/architekt-on-demand/form',
              loaderName: 'getServerSideProps',
              ...__i18nConfig,
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
            }))
          }
        }
    }
  